<div fxLayout="column" fxFlexFill style="position: relative">
  <div fxLayout="column" fxFlexFill class="spinner-container" *ngIf="dataSource.loading$ | async">
    <mat-spinner></mat-spinner>
  </div>
  <div fxFlex="auto" fxFlexFill class="table-container">
    <mat-table [dataSource]="dataSource" multiTemplateDataRows class="regular-table responsive"
               matSort matSortActive="faxDate" matSortDirection="desc" matSortDisableClear>
      <ng-container matColumnDef="type">
        <mat-header-cell *matHeaderCellDef mat-sort-header="type">Direction</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Direction:</span>
          <span [ngClass]="{
                    'badge-outgoing': row.type == 'outgoing',
                    'badge-incoming': row.type == 'incoming'
                    }">
            <i class="material-icons">{{row.type == 'outgoing' ? 'call_made' : 'call_received'}}</i>
            {{row.type}}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="faxDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header="faxDate">Date</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Date:</span>
          <span>
            {{row.faxDate | dateTime: 'M/dd/yyyy hh:mm a'}}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="tnTo">
        <mat-header-cell *matHeaderCellDef mat-sort-header="tnTo">To</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">To:</span>
          <span fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <span>{{row.tnTo | phoneNumber}}</span>
            <span *ngIf="row.contactTo" style="white-space: nowrap"> – {{row.contactTo.name}}</span>
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="tnFrom">
        <mat-header-cell *matHeaderCellDef mat-sort-header="tnFrom">From</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">From:</span>
          <span fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <span>{{row.tnFrom | phoneNumber}}</span>
            <span *ngIf="row.contactFrom" style="white-space: nowrap"> – {{row.contactFrom.name}}</span>
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef mat-sort-header="status">Status</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Status:</span>
          <span>
            <span>{{row.status}}</span>
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="pages">
        <mat-header-cell *matHeaderCellDef mat-sort-header="pages">Pages</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Pages:</span>
          {{ row.pages }}
        </mat-cell>
      </ng-container>

      <!-- Header and Row Declarations -->
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" class="call-logs-row"></mat-row>
    </mat-table>
  </div>
  <mat-paginator fxFlex="initial" [length]="dataSource.dataCount$ | async" [pageSize]="100"></mat-paginator>
</div>
